<template>
  <div class="landing-wrapper">
    <!-- Navbar -->
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />

    <!-- Hero Section -->
    <HeroSection /> 
    
    <!-- Features Strip -->
    <FeaturesStrip />
    
    <!-- Fonctionnement -->
    <Fonctionnement /> 

    <AvantagesSection />
  <TrustSection />

    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import HeroSection from '@/components/HeroSection.vue';
import FeaturesStrip from '@/components/FeaturesStrip.vue';
import Fonctionnement from '@/components/Fonctionnement.vue';
import AvantagesSection from '@/components/AvantagesSection.vue'
import TrustSection from '@/components/TrustSection.vue'
const body = document.getElementsByTagName("body")[0];

export default {
  name: "LandingPage",
  components: {
    Navbar,
    AppFooter,
    HeroSection,
    FeaturesStrip,
    AvantagesSection,
    TrustSection,
    Fonctionnement
  },
  data() {
    return {
      activeFaq: null,
      faqs: [
        {
          question: "Comment créer un compte Nolido ?",
          answer: "Téléchargez l'application, inscrivez-vous avec votre numéro de téléphone et suivez les étapes de vérification. C'est simple et rapide !"
        },
        {
          question: "Quels sont les frais de transfert ?",
          answer: "Nos frais sont transparents et compétitifs. Ils varient selon le montant et le pays de destination. Consultez notre grille tarifaire dans l'application."
        },
        {
          question: "Combien de temps prend un transfert ?",
          answer: "Les transferts sont instantanés dans la plupart des cas. Le destinataire reçoit l'argent en quelques secondes."
        },
        {
          question: "Est-ce sécurisé ?",
          answer: "Absolument ! Nous utilisons les dernières technologies de cryptage et respectons les normes de sécurité bancaire internationales."
        },
        {
          question: "Dans quels pays Nolido est-il disponible ?",
          answer: "Nolido est actuellement disponible dans 8 pays d'Afrique de l'Ouest et nous continuons notre expansion."
        }
      ]
    };
  },
  computed: {
    personLeftStyle() {
      return {
        backgroundImage: `url(${require('@/assets/img/Left Image.png')})`
      };
    },
    personRightStyle() {
      return {
        backgroundImage: `url(${require('@/assets/img/Rignt Image.png')})`
      };
    }
  },
  created() {
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    body.classList.add("bg-gray-100");
  },
  methods: {
    toggleFaq(index) {
      this.activeFaq = this.activeFaq === index ? null : index;
    }
  }
};
</script>

<style scoped>
/* ============= Global Styles ============= */
:root {
  --primary-orange: #F5A847;
  --dark-text: #2B2B2B;
}

.landing-wrapper {
  background: #ffffff;
  overflow-x: hidden;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #F69800 #f1f1f1;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, #FFF9F0 0%, #FFFFFF 100%);
  padding: 8rem 0 2rem;
  padding-bottom: 100px;
  position: relative;
  overflow: hidden;
  min-height: 600px;
}

.hero-content {
  z-index: 5;
}

.satisfaction-badge {
  display: inline-flex;
  align-items: center;
  gap: 1.2rem;
  background: white;
  padding: 0.6rem 1.8rem;
  border-radius: 50px;
  border: 2px solid #E5E5E5;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  margin-bottom: 2rem;
  font-size: 0.95rem;
}

.badge-separator {
  width: 1px;
  height: 30px;
  background-color: #E5E5E5;
}

.satisfaction-text,
.avis-text {
  color: #1a1a1a;
  font-size: 0.95rem;
  white-space: nowrap;
}

.satisfaction-text strong,
.avis-text strong {
  font-weight: 600;
}

.user-avatars {
  display: flex;
  margin-right: 0;
}

.user-avatars img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid white;
  margin-left: -12px;
  object-fit: cover;
}

.user-avatars img:first-child {
  margin-left: 0;
}

.hero-title-container {
  max-width: 900px;
  margin: 0 auto;
}

.hero-title {
  font-size: 5rem;
  font-weight: 900;
  color: #2F2113;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}

.hero-subtitle {
  font-size: 1.35rem;
  color: #9B9B9B;
  margin-bottom: 3rem;
  line-height: 1.6;
  font-weight: 400;
}

.store-buttons {
  display: flex;
  gap: 1.2rem;
  justify-content: center;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.store-btn {
  background: #2F2113;
  padding: 0.5rem 2rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  color: white;
  text-decoration: none;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0 4px 12px rgba(47, 33, 19, 0.2);
}

.store-btn:hover {
  transform: translateY(-3px);
  color: white;
  box-shadow: 0 8px 20px rgba(47, 33, 19, 0.3);
}

.store-btn i {
  font-size: 1.5rem;
}

.store-btn-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.02rem;
}

.store-btn-text small {
  font-size: 0.65rem;
  font-weight: 400;
  opacity: 0.85;
  display: block;
  line-height: 1;
}

.store-btn-text strong {
  font-size: 0.9rem;
  font-weight: 600;
  display: block;
  line-height: 1.1;
}

.flags-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  margin-top: 3rem;
}

.flags-garland {
  max-width: 600px;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.country-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0rem;
  position: relative;
}

.country-text {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #1a1a1a;
  font-size: 1rem;
  font-weight: 500;
}

.country-text i {
  font-size: 1.2rem;
}

.underline-curve {
  width: auto;
  max-width: 100%;
  height: auto;
  margin-top: -5px;
}

.person-left, .person-right {
  position: absolute;
  width: 300px;
  height: auto;
  max-height: 650px;
  object-fit: contain;
  z-index: 2;
  bottom: 0;
}

.person-left {
  left: -10px;
}

.person-right {
  right: -10px;
}

.phone-mockup {
  position: absolute;
  right: 5%;
  bottom: -20px;
  width: 200px;
  max-height: 450px;
  z-index: 10;
  object-fit: contain;
  border-radius: 30px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}

@media (max-width: 992px) {
  .hero-title {
    font-size: 3.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.15rem;
  }
  
  .person-left, .person-right {
    width: 200px;
    max-height: 350px;
  }
  
  .phone-mockup {
    width: 160px;
    max-height: 360px;
    right: 50%;
    transform: translateX(50%);
    bottom: -60px;
  }
  
  .hero-section {
    min-height: 500px;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-subtitle {
    font-size: 1rem;
  }
  
  .store-btn {
    padding: 0.75rem 1.5rem;
  }
  
  .store-btn i {
    font-size: 1.6rem;
  }
  
  .store-btn-text strong {
    font-size: 0.95rem;
  }
  
  .store-btn-text small {
    font-size: 0.7rem;
  }
  
  .flags-garland {
    max-width: 100%;
  }
  
  .country-text {
    font-size: 0.9rem;
  }
  
  .underline-curve {
    max-width: 220px;
  }
  
  .satisfaction-badge {
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
  }
  
  .person-left, .person-right {
    width: 140px;
    max-height: 250px;
  }
  
  .person-left {
    left: -30px;
  }
  
  .person-right {
    right: -30px;
  }
  
  .hero-section {
    padding: 6rem 0 2rem;
  }
}

@media (max-width: 576px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-subtitle {
    font-size: 0.9rem;
    padding: 0 1rem;
  }
  
  .person-left, .person-right {
    width: 100px;
    max-height: 180px;
  }
  
  .person-left {
    left: -20px;
  }
  
  .person-right {
    right: -20px;
  }
  
  .satisfaction-badge {
    font-size: 0.85rem;
    padding: 0.8rem 1.2rem;
  }
  
  .user-avatars img {
    width: 30px;
    height: 30px;
  }
  
  .badge-separator {
    height: 24px;
  }
  
  .flags-garland {
    max-width: 90%;
  }
  
  .store-buttons {
    gap: 0.8rem;
  }
  
  .hero-section {
    padding: 5rem 0 2rem;
    min-height: 450px;
  }
}

/* Section Avantages */
.advantages-section {
  position: relative;
  background: white;
  padding: 4rem 0 0;
}

.advantages-cards {
  margin-bottom: 0;
  position: relative;
  z-index: 2;
}

.advantage-card {
  text-align: left;
  background: white;
  margin-bottom: 2rem;
}

.advantage-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 1.5rem 0;
}

.advantage-icon i {
  font-size: 28px;
  color: #2F2113;
}

.advantage-icon-img {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

.advantage-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 1rem;
}

.advantage-text {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.background-image-section {
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
  border-radius: 12px;
}

.bg-main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.transfer-badge {
  position: absolute;
  bottom: 130px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.12);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  z-index: 3;
}

.flag-badge {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
  flex-shrink: 0;
}

.badge-content {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.badge-text {
  font-size: 0.85rem;
  color: #878787;
  font-weight: 400;
  font-style: italic;
}

.badge-amount {
  font-size: 1.1rem;
  font-weight: 900;
  color: #1a1a1a;
  letter-spacing: -0.02em;
}

@media (max-width: 768px) {
  .advantages-section {
    padding: 2rem 0 0;
  }
  
  .advantage-card {
    padding: 1.5rem 1rem;
  }
  
  .advantage-title {
    font-size: 1.1rem;
  }
  
  .advantage-text {
    font-size: 0.9rem;
  }
  
  .background-image-section {
    height: 350px;
  }
  
  .transfer-badge {
    padding: 0.4rem 0.8rem;
    bottom: 30px;
    gap: 0.5rem;
  }
  
  .flag-badge {
    width: 28px;
    height: 28px;
  }
  
  .badge-text {
    font-size: 0.75rem;
  }
  
  .badge-amount {
    font-size: 0.95rem;
  }
}

/* Section Finance Fluide */
.finance-section {
  background: #F8F8F8;
  padding: 80px 0;
  position: relative;
  overflow: hidden;
}

.finance-image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.phone-finance {
  max-width: 320px;
  width: 100%;
  height: auto;
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 20px 40px rgba(0,0,0,0.15));
}

.decoration-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 70px;
  height: auto;
  opacity: 0.8;
  z-index: 1;
}

.decoration-bottom {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 90px;
  height: auto;
  opacity: 0.8;
  z-index: 1;
}

/* Final CTA Section */
/* Final CTA Section */
/* Final CTA Section */
.final-cta-section {
  background-color: #2F2113;
  position: relative;
  overflow: hidden;
  height: 700px; /* Limit height */
  padding-top: 2rem;
  background-image: url('~@/assets/img/bande_gauche.png');
  background-position: left 50px;
  background-repeat: no-repeat;
  background-size: 350px auto;
}

.decoration-curve {
  top: 60px !important;
  left: 0 !important;
  opacity: 1;
  z-index: 1;
  width: 400px;
}



/* Increased underline size */
.underline-svg {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 250px; 
  height: auto;
}

.btn-download-cta {
  background-color: #eebb89;
  color: #2F2113;
  font-weight: 700;
  border: none;
  font-size: 0.95rem; /* Reduced font size */
  padding: 0.6rem 2rem; /* Reduced padding */
  box-shadow: 0 4px 0 #c29568;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  z-index: 10;
}

.btn-download-cta:hover {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #c29568;
}

/* Positioning phone absolute bottom-left */
.phone-wrapper {
  position: absolute;
  bottom: -40px; /* Cut off at bottom */
  left: 5%;
  z-index: 5;
  width: 280px; 
}

.phone-app-img {
  width: 100%;
  height: auto;
  transform: rotate(0deg); /* Ensure straight */
}

/* Positioning collage absolute bottom-right */
.collage-wrapper {
  position: absolute;
  bottom: 60px;
  right: 2%;
  z-index: 5;
  width: 360px;
}

.collage-img {
  width: 100%;
  height: auto;
  transform: rotate(3deg);
  border-radius: 12px;
  box-shadow: none;
}

@media (max-width: 991px) {
  .final-cta-section {
    height: auto;
    min-height: 500px;
    padding-bottom: 0;
    background-image: none; /* Hide background on mobile to prevent overlap */
    padding-top: 3rem;
  }
  
  .phone-wrapper {
    position: relative;
    bottom: 0;
    left: 0;
    margin-top: 2rem;
    margin-bottom: -10px; /* Flush to bottom */
    display: inline-block;
  }
  
  .collage-wrapper {
    position: relative;
    bottom: 0;
    right: 0;
    display: inline-block;
  }
  
  .collage-img {
    transform: rotate(0);
  }
}
.finance-content {
  padding: 2rem;
  padding-left: 3rem;
}




.finance-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #1A1A1A;
  line-height: 1.15;
  margin-bottom: 1.25rem;
  letter-spacing: -0.03em;
}

.finance-description {
  font-size: 1.05rem;
  color: #4A4A4A;
  line-height: 1.65;
  margin-bottom: 2rem;
  font-weight: 400;
}

.btn-discover {
  display: inline-block;
  background: #F5A847;
  color: #2F2113;
  padding: 0.85rem 2.25rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(245, 168, 71, 0.3);
  border: none;
}

.btn-discover:hover {
  background: #E69535;
  color: #2F2113;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 168, 71, 0.4);
}

/* Section Défis Financiers */
.defis-section {
  background: white;
  padding: 80px 0;
  position: relative;
}

.defis-content {
  padding: 2rem;
  padding-right: 3rem;
}

.defis-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #1A1A1A;
  line-height: 1.15;
  margin-bottom: 1.25rem;
  letter-spacing: -0.03em;
}

.defis-description {
  font-size: 1.05rem;
  color: #4A4A4A;
  line-height: 1.65;
  margin-bottom: 2.5rem;
  font-weight: 400;
}

.defis-points {
  margin-bottom: 2.5rem;
}

.point-item {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.75rem;
  align-items: flex-start;
}

.point-icon-circle {
  width: 48px;
  height: 48px;
  background: #FFF5E8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.point-icon-circle i {
  font-size: 22px;
  color: #F5A847;
}

.point-content {
  flex: 1;
}

.point-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1A1A1A;
  margin-bottom: 0.4rem;
}

.point-desc {
  font-size: 0.95rem;
  color: #5A5A5A;
  line-height: 1.6;
  margin: 0;
  font-weight: 400;
}

.defis-images {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 520px;
}

.defis-img-main {
  width: 340px;
  height: 420px;
  object-fit: cover;
  border-radius: 24px;
  position: relative;
  z-index: 2;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.defis-img-overlay {
  width: 270px;
  height: 340px;
  object-fit: cover;
  border-radius: 20px;
  position: absolute;
  bottom: 20px;
  right: 30px;
  z-index: 3;
  box-shadow: 0 25px 50px rgba(0,0,0,0.18);
  border: 5px solid white;
}

.defis-decoration {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 90px;
  height: auto;
  opacity: 0.75;
  z-index: 1;
}

@media (max-width: 992px) {
  .finance-section,
  .defis-section {
    padding: 60px 0;
  }

  .finance-title,
  .defis-title {
    font-size: 2rem;
  }

  .phone-finance {
    max-width: 280px;
  }

  .defis-images {
    min-height: 400px;
    margin-top: 3rem;
  }

  .defis-img-main {
    width: 280px;
    height: 320px;
  }

  .defis-img-overlay {
    width: 220px;
    height: 260px;
    right: 20px;
    bottom: 20px;
  }
}

@media (max-width: 768px) {
  .finance-content,
  .defis-content {
    padding: 1rem;
  }

  .finance-title,
  .defis-title {
    font-size: 1.75rem;
  }

  .finance-description,
  .defis-description {
    font-size: 0.95rem;
  }

  .decoration-top {
    width: 40px;
    top: 10px;
    left: 10px;
  }
  
  .decoration-bottom {
    width: 50px;
    bottom: 10px;
    right: 10px;
  }
  
  .defis-decoration {
    width: 50px;
    top: 10px;
    left: 10px;
  }

  .point-icon-circle {
    width: 40px;
    height: 40px;
  }

  .point-icon-circle i {
    font-size: 18px;
  }

  .point-title {
    font-size: 1rem;
  }

  .point-desc {
    font-size: 0.9rem;
  }

  .defis-images {
    min-height: 350px;
    padding: 1rem;
  }

  .defis-img-main {
    width: 220px;
    height: 280px;
  }

  .defis-img-overlay {
    width: 180px;
    height: 220px;
    right: 10px;
    bottom: 10px;
  }
}

@media (max-width: 576px) {
  .finance-title,
  .defis-title {
    font-size: 1.5rem;
  }

  .finance-description,
  .defis-description {
    font-size: 0.85rem;
  }

  .phone-finance {
    max-width: 220px;
  }

  .decoration-top {
    width: 30px;
  }
  
  .decoration-bottom {
    width: 35px;
  }
  
  .defis-decoration {
    width: 35px;
  }

  .defis-images {
    min-height: 280px;
    padding: 0.5rem;
  }

  .defis-img-main {
    width: 170px;
    height: 220px;
  }

  .defis-img-overlay {
    width: 140px;
    height: 180px;
    right: 5px;
    bottom: 5px;
    border: 3px solid white;
  }
  
  .point-item {
    gap: 0.75rem;
  }
  
  .btn-discover {
    font-size: 0.85rem;
    padding: 0.75rem 1.75rem;
  }
}
</style>